<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/stock/transfers">{{$t('stock_transfer')}}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('new') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <b-btn variant="outline-primary no-bor" size="sm" @click="save"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('save')}}</b-btn>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label class="control-label blue">{{$t('branch_from')}}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="header.FromBranchId" @change="fromBranch">
                                        <option v-for="ret in branchs" :value="ret.Id" :key="ret.Id">{{ ret.Name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label class="control-label blue">{{$t('branch_to')}}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="header.ToBranchId">
                                        <option v-for="ret in branchs" :value="ret.Id" :key="ret.Id">{{ ret.Name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="control-label blue">{{$t('date')}}</label>
                                <div>
                                    <input type="date" class="form-control form-control-sm" v-model="header.Date" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                    <div class="row">
                        <div class="col-sm-12">
                            <div style="display: flex; gap: 5px;">
                                <button type="button" class="btn btn-outline-primary btn-sm" @click="addLine">
                                    <i class="fa fa-plus" /> {{ $t('add_line') }}
                                </button>
                                <button v-if="hasChecked" type="button" class="btn btn-outline-danger btn-sm" @click="removeLine">
                                    <i class="fa fa-times" /> {{ $t('remove') }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <br />
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table table-bordered table-hover table-sm no-bor">
                                <thead>
                                    <tr>
                                        <th class="text-center" style="width: 20px;"><input type="checkbox" v-model="checkAll"></th>
                                        <th>{{$t('item_code')}}</th>
                                        <th>{{$t('item_name')}}</th>
                                        <th>{{$t('description')}}</th>
                                        <th>{{$t('qty')}}</th>
                                        <th>{{$t('uom')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ret,index) in lines" :key="index">
                                        <td class="text-center"><input type="checkbox" v-model="ret.Checked"></td>
                                        <td>{{ret.ItemCode}}</td>
                                        <td>{{ret.ItemName}}</td>
                                        <td class="cell-input">
                                            <input type="text" class="form-control form-control-sm" v-model="ret.Description" />
                                        </td>
                                        <td class="cell-input">
                                            <input type="text" class="form-control form-control-sm text-right" v-model="ret.Quantity">
                                        </td>
                                        <td>{{ret.UomName}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <br />
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="control-label blue">{{$t('note')}}</label>
                                <div>
                                    <textarea type="text" class="form-control form-control-sm" v-model="header.Remark"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ItemBranchSelect ref="item" :v-branch-id="header.FromBranchId"
                          :v-item-ids="includeIds"
                          @selected="itemSelected"></ItemBranchSelect>
    </div>
</template>
<script>
    import { ItemBranchSelect } from '../Item';
    export default {
        components: {
            ItemBranchSelect
        },
        data: function () {
            return {
                branchs: [],
                header: {
                    FromBranchId: '',
                    ToBranchId: '',
                    Date: this.$now().format('YYYY-MM-DD')
                },
                lines: [],
                checkAll: false
            }
        },
        created() {
            this.branchList();
            let id = this.$route.params.id;
            if (id != undefined && id != '') {
                this.findById(id);
            }
        },
        methods: {
            findById(id) {
                let loading = this.$loading.show();
                this.$api().post('stock/transfer/find', { Id: id }).then(res => {
                    if (this.$isValid(res)) {
                        this.header = res.data.Json.Header;
                        this.header.Date = this.$format(this.header.Date, 'YYYY-MM-DD');
                        this.lines = res.data.Json.Lines;
                    }
                }).finally(function () { loading.hide(); });
            },
            branchList() {
                this.$api().post('branch/list', { CompanyId: this.$store.state.company.Id }).then(res => {
                    if (this.$isValid(res)) {
                        this.branchs = res.data.Json.Branches;
                    }
                });
            },
            save() {
                this.header.CompanyId = this.$store.state.company.Id;
                this.header.ClientId = this.$store.state.company.ClientId;
                var loading = this.$loading.show();
                var req = {
                    Header: this.header,
                    Lines: this.lines
                }
                this.$api().post('stock/transfer/save', req).then(res => {
                    if (this.$isValid(res)) {
                        this.$router.push('/stock/transfers');
                    }
                }).finally(() => { loading.hide() });
            },
            itemSelected(items) {
                items.forEach(element => {
                    this.lines.push({
                        Checked: false,
                        ItemId: element.ItemId,
                        ItemCode: element.ItemCode,
                        ItemName: element.ItemName,
                        Description: element.ItemName,
                        UomId: element.UomId,
                        UomName: element.UomName,
                        Quantity: 1
                    });
                });
            },
            addLine() {
                if (this.header.FromBranchId != '') {
                    this.$refs.item.$refs.innermodal.show();
                } else {
                    this.$swal.fire('Waring Message', 'Please select from branch', 'warning');
                }
            },
            removeLine() {
                this.lines = this.lines.filter(el => el.Checked == false);
            },
            fromBranch() {
                this.$refs.item.$refs.innermodal.show();
            }
        },
        computed: {
            includeIds() {
                let res = [];
                for (var i = 0; i < this.lines.length; i++) {
                    res.push(this.lines[i].ItemId);
                }
                return res;
            },
            hasChecked() {
                return this.lines.filter(el => el.Checked == true).length;
            }
        },
        watch: {
            checkAll(value) {
                this.lines.forEach(el => el.Checked = value);
            }
        }
    }
</script>
